import Queue from "nq";

class DeleteObjectUseCase {
  async execute(collection, id, options) {
    const data = {
      id,
      acl: { read: [], write: [] },
    };
    return new Queue.Document().update(collection, data, options);
    // return new Queue.Document().delete(collection, id, options);
  }
}

export default DeleteObjectUseCase;
